import React from 'react';
import ReactDOM from 'react-dom/client'; // Updated import
import './styles.css'; // Ensure this import is present
import App from './App';

// Remove the import and usage of reportWebVitals
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root')); // Updated to use createRoot
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Remove the call to reportWebVitals
// reportWebVitals();
